import React, { useEffect, useState } from "react";
import { Link, useParams } from "react-router-dom";
import axios from "axios";
import LandingSliderPages from "../section/LandingSliderPages";
import { addToCart } from "../utils/cartUtils";
import { toast } from "react-toastify";

export default function MenuList() {
    const { categoryId } = useParams();
    const [products, setProducts] = useState([]);
    const [loading, setLoading] = useState(true);

    useEffect(() => {
        console.log("Fetching products for categoryId:", categoryId);
        axios
            .get("https://laravel-api.petra-ms.com/api/products")
            .then((response) => {
                console.log("API Response:", response.data);
                if (response.data.success) {
                    const filteredProducts = response.data.data.filter(
                        (product) => product.product_category === parseInt(categoryId)
                    );
                    console.log("Filtered Products:", filteredProducts);
                    setProducts(filteredProducts);
                }
                setLoading(false);
            })
            .catch((error) => {
                console.error("Error fetching products:", error);
                setLoading(false);
            });
    }, [categoryId]);

    const handleAddToCart = (product) => {
        const cartItem = {
            id: product.id,
            name: product.product_name,
            price: product.product_price,
            image: `https://laravel-api.petra-ms.com/storage/app/public/${product.product_img}`,
        };
        addToCart(cartItem);
        toast.success(`${product.product_name} added to cart!`, {
            position: "top-right",
            autoClose: 2000,
        });
    };

    const showData = products.map((el) => (
        <Link
            to={`/items-details/${el.id}`}
            key={el.id}
            className="flex bg-white p-[15px] rounded-[8px] gap-[30px]"
        >
            <div className="w-[20%]">
                <img
                    className="w-full h-full object-cover rounded-[8px]"
                    src={`https://laravel-api.petra-ms.com/storage/app/public/${el.product_img}`}
                    alt={el.product_name}
                    onError={(e) => console.log(`Failed to load image: ${e.target.src}`)}
                />
            </div>
            <div className="flex flex-col justify-between gap-[30px]">
                <div>
                    <div className="text-[20px] font-bold capitalize">{el.product_name}</div>
                    <p className="text-[#979797]">{el.product_description}</p>
                    <div className="font-bold">{el.product_price} {el.product_currency}</div>
                </div>
                <button
                    onClick={(e) => {
                        e.preventDefault();
                        handleAddToCart(el);
                    }}
                    className="w-fit py-[10px] px-[40px] flex items-center justify-center bg-[#20BCB4] text-white rounded-[4px] h-10"
                >
                    <span>Add To Cart</span>
                </button>
            </div>
        </Link>
    ));

    console.log("showData:", showData);

    return (
        <>
            <section>
                <LandingSliderPages />
            </section>
            <section className="relative py-10">
                <div className="container flex flex-col gap-[20px]">
                    <div className="flex items-end justify-end">
                        <div className="bg-white flex items-center gap-[4px] py-[10px] px-[30px] rounded-[4px] shadow-[0_0_10px_#0000003d]">
                            <img
                                className="w-[20px] h-[20px]"
                                src={require("../../assets/icons/filter.svg").default}
                                alt=""
                            />
                            <div className="font-bold capitalize">filter</div>
                        </div>
                    </div>
                    <div className="flex flex-col gap-[12px]">
                        {loading ? (
                            <div className="text-center">Loading...</div>
                        ) : products.length === 0 ? (
                            <div className="text-center">No products available for this category.</div>
                        ) : (
                            showData
                        )}
                    </div>
                </div>
            </section>
        </>
    );
}